export interface ITablesData {
    datakey: string;
    title: string;
    type: string;
    headColumns: string[];
    bodyColumns: string[];
    selected?: boolean;
    tapCode?: string;
}
export const TablesData: ITablesData[] = [
    {
        datakey: 'Allergy',
        title: 'ALLERGY',
        type: 't02',
        headColumns: ['DrugNameEn', 'CategoryNameEn', 'USERNAME', 'RegDate'],
        bodyColumns: ['drugNameEn', 'categoryNameEn', 'userName', 'regDate'],
        selected: false,
        tapCode: 'Allergy'
    },
     {
        datakey: 'History',
        title: 'EMRPATHISTORY',
        type: 't01',
        headColumns: ['TYPE', 'Name', 'STARTDATE', 'ENDDATE', 'NOTES', 'USERNAME'],
        bodyColumns: ['historyTypeAr', 'nameAr', 'startDate', 'endDate', 'notes', 'userName'],
        selected: false,
        tapCode: 'History'
    },
  
    {
        datakey: 'Diagnois',
        title: 'DIAGNOSES',
        type: 't02',
        headColumns: ['DIAGNOSES', 'STATUS', 'NOTES', 'USERNAME', 'RegDate'],
        bodyColumns: ['description', 'statusEn', 'notes', 'userName', 'regDate'],
        selected: false,
        tapCode: 'Diagnois'
    },
    {
        datakey: 'Complain',
        title: 'COMPLAINTS',
        type: 't01',
        headColumns: ['COMPLAINTS', 'ONSET', 'COURSE', 'DURATION', 'USERNAME', 'RegDate'],
        bodyColumns: ['complaintDescEn', 'onSet', 'course', 'duration', 'userName', 'regDate'],
        selected: false,
        tapCode: 'Complains'
    },
    {
        datakey: 'Findings',
        title: 'FINDINGS',
        type: 't02',
        headColumns: ['FINDINGS', 'Notes', 'USERNAME', 'RegDate'],
        bodyColumns: ['description', 'notes', 'userName', 'regDate'],
        selected: false,
        tapCode: 'Finding'
    },
 
    {
        datakey: 'Medication',
        title: 'MEDICATIONDOSES',
        type: 't01',
        headColumns: ['ITEMNAME', 'DOSE', 'DOCTOR', 'DATETIME'],
        bodyColumns: ['nameEn', 'rxDescEn', 'docNameEn', 'startDate'],
        selected: false,
        tapCode: 'MEDICATION'
    }
    ,
    {
        datakey: 'Rad',
        title: 'RADIOLOGY',
        type: 't02',
        headColumns: ['SERVICENAME', 'STATUS', 'DOCTOR', 'DATETIME'],
        bodyColumns: ['serviceNameEn', 'serviceStatusEn', 'docNameEn', 'expectedStartTime'],
        selected: false,
        tapCode: 'RAD_ORDERS'
    }
    ,
    {
        datakey: 'Lab',
        title: 'LABORATORY',
        type: 't01',
        headColumns: ['SERVICENAME', 'STATUS', 'DOCTOR', 'DATETIME'],
        bodyColumns: ['serviceNameEn', 'serviceStatusEn', 'docNameEn', 'expectedStartTime'],
        selected: false,
        tapCode: 'LAB_ORDERS'
    }
    ,
    {
        datakey: 'GlasgowComaScale',
        title: 'GLASGOWCOMASCALE',
        type: 't02',
        headColumns: ['BESTEYERESPONSE', 'BESTMOTORRESPONSE', 'BESTVERDALRESPONSE', 'RESULT', 'USERNAME'],
        bodyColumns: ['bestEyeText', 'bestMotorText', 'bestVerbalText', 'result', 'reuserNamesult'],
        selected: false,
        tapCode: 'GLASGOWCOMA_SCORES'
    },
    {
        datakey: 'BehavioralPainScale',
        title: 'BEHAVIORALPAINSCALE',
        type: 't01',
        headColumns: ['FACIALEXPRESSION', 'UPPERLIMBMOVE', 'MECHANICALVENTILATIONCOMPLIENCE', 'RESULT', 'USERNAME'],
        bodyColumns: ['facialExpressionText', 'upperLimbMovementsText', 'compMechVentText', 'result', 'reuserNamesult'],
        selected: false,
        tapCode: 'BEHAVIORALPAIN_SCORES'
    }
    ,
    {
        datakey: 'NonverbalPainScale',
        title: 'NONVERBALPAINSCALE',
        type: 't02',
        headColumns: ['FACE', 'ACTIVITY', 'GUARDING', 'PHYSIOLOGY', 'VSRR', 'RESULT', 'USERNAME', 'RegDate'],
        bodyColumns: ['faceText', 'activityText', 'guardingText', 'physiologyText', 'respiratoryText', 'result', 'userName', 'regDate'],
        selected: false,
        tapCode: 'NONVERBALPAIN_SCORES'
    },
    {
        datakey: 'EmrClinicalOrders',
        title: 'NURSINGCAREPLAN',
        type: 't01',
        headColumns: ['DOTORORDER', 'NOTES', 'USER', 'RegDate'],
        bodyColumns: ['orderDescEn', 'notesOnOrder', 'userName', 'regDate'],
        selected: false,
        tapCode: 'NU-CARE'
    }
    ,
    {
        datakey: 'EmrClinicalNotes',
        title: 'NURSINGCAREPLAN',
        type: 't02',
        headColumns: ['DOTORORDER', 'NOTES', 'USER', 'RegDate'],
        bodyColumns: ['orderDescEn', 'notes', 'userName', 'regDate'],
        selected: false,
        tapCode: 'NU-FOLLOWUP'
    }
   
]